import React from "react";
import { graphql } from "gatsby";
import SliderHero from "./slider-hero";
import SliderProdotti from "./slider-prodotti";
import EditorialIntro from "./editorial-intro";
import Promozioni from "./promozioni";
import HomeBanner from "./home-banner";
import Newsletter from "./newsletter";
import HomeStories from "./home-stories";
import BannerFeatures from "./banner-features";
import ItemsGrid from "./items-grid";
import SliderGallery from "./slider-gallery";
import SliderGamma from "./slider-gamma";
import Intro from "./intro";
import OnlineStore from "./online-store";
import Assistance from "./assistance";
import AssistanceFooter from "./assistance-footer";
import StoreLocationWrapper from "./store-location-wrapper";
import Form from "./form";
import FaqPage from "./faq-page";
import RequestRepairForm from "./request-repair-form";
import Manuali from "./manuali";
import withPreview from "../utility/with-preview";
import FaqWashPass from "./faq-washpass";
import ProductNotes from "./elements/product-notes";
import Highlight from "./highlight";
import Switch from "./tab-configurator";
import Info from "./info";
import EditorialPush from "./editorial-push";
import CodeValidator from "./code-validator";
import AccordionInfo from "./accordion-info";
import BannerPushApp from "./banner-push-app";
import Pin from "./pin";
import HtmlTextField from "./html-text-field";
import CategoryModule from "./category-module";

const RawLiferayComponent = ({
  data,
  config,
  labelManagerLabels,
  location,
  origin,
  breadcrumb,
  isFirst,
  pagePath,
}) => (
  <React.Fragment>
    {
      {
        LiferaySliderHero: (
          <SliderHero data={data} breadcrumb={breadcrumb} isFirst={isFirst} origin={origin} />
        ),
        LiferayFeaturedProduct: (
          <SliderProdotti
            data={data}
            location={location}
            config={config}
            origin={origin}
            labelManagerLabels={labelManagerLabels}
            isFirst={isFirst}
          />
        ),
        LiferayPurchaseMotivation: <BannerFeatures data={data} isFirst={isFirst} />,
        LiferayPromo: <Promozioni data={data} isFirst={isFirst} />,
        LiferayBlogPage: <HomeStories data={data} location={location} isFirst={isFirst} />,
        LiferayService: <HomeBanner data={data} isFirst={isFirst} />,
        LiferayNewsletter: <Newsletter data={data} />,
        LiferayEditorial: <EditorialIntro data={data} breadcrumb={breadcrumb} isFirst={isFirst} />,
        LiferayDynamicTriplettaListing: (
          <ItemsGrid data={data} isProduct={false} isFirst={isFirst} />
        ),
        LiferayGallery: <SliderGallery data={data} isFirst={isFirst} />,
        LiferayCompare: (
          <SliderGamma
            data={data}
            labelManagerLabels={labelManagerLabels}
            config={config}
            origin={origin}
            location={location}
            isFirst={isFirst}
          />
        ),
        LiferayIntro: <Intro data={data} breadcrumb={breadcrumb} isFirst={isFirst} />,
        LiferayOnlineStore: <OnlineStore data={data} />,
        LiferayAssistance: <Assistance data={data} />,
        LiferayAssistanceFooter: <AssistanceFooter data={data} />,
        LiferayStoreLocation: <StoreLocationWrapper data={data} location={location} />,
        LiferayFormConfiguration: <Form data={data} location={location} />,
        LiferayBooklet: <Manuali data={data} labelManagerLabels={labelManagerLabels} />,
        LiferayFaqPage: <FaqPage data={data} />,
        // LiferayServiceMaps: <ServiceMaps data={data} breadcrumb={breadcrumb} />,
        LiferayRequestRepairForm: <RequestRepairForm data={data} breadcrumb={breadcrumb} />,
        LiferayFaq: <FaqWashPass data={data} isFirst={isFirst} />,
        LiferayProductNotes: <ProductNotes data={data} position="plp" />,
        LiferayHighlight: <Highlight data={data} />,
        LiferaySwitch: (
          <Switch
            data={data}
            location={location}
            isFirst={isFirst}
            config={config}
            labelManagerLabels={labelManagerLabels}
            pagePath={pagePath}
          />
        ),
        LiferayInfoModule: <Info data={data} isFirst={isFirst} />,
        LiferayEditorialPush: <EditorialPush data={data} isFirst={isFirst} />,
        LiferayWashpassCodeValidator: <CodeValidator data={data} />,
        LiferayAccordionInfo: <AccordionInfo data={data} />,
        LiferayProductApp: <BannerPushApp data={data} position="pdp" />,
        LiferayPin: <Pin data={data} isFirst={isFirst} pagePath={pagePath} />,
        LiferayHtmlTextField: <HtmlTextField data={data} />,
        LiferayCategoryModule: <CategoryModule data={data} pagePath={pagePath} />,
      }[data.__typename]
    }
  </React.Fragment>
);

export default withPreview(RawLiferayComponent);

export const fragment = graphql`
  fragment ContentBodyFragment on LiferayPage {
    contentBody {
      __typename
      ...SliderHeroFragment
      ...FeaturedProductFragment
      ...PurchaseMotivationFragment
      ...PromoFragment
      ...BlogPageFragment
      ...ServiceFragment
      ...NewsletterFragment
      ...EditorialFragment
      ...DynamicTriplettaListingFragment
      ...GalleryFragment
      ...CompareFragment
      ...IntroFragment
      ...OnlineStoreFragment
      ...AssistanceFragment
      ...AssistanceFooterFragment
      ...StoreLocationFragment
      ...FormConfigurationFragment
      ...BookletFragment
      ...FaqPageFragment
      ...ServiceMapsFragment
      ...RequestRepairFormFragment
      ...FaqWashPassFragment
      ...ProductNotesFragment
      ...HighLightFragment
      ...SwitchFragment
      ...InfoModuleFragment
      ...EditorialPushFragment
      ...WashpassCodeValidatorFragment
      ...AccordionInfoFragment
      ...ProductAppFragment
      ...PinFragment
      ...HtmlTextFieldFragment
      ...CategoryModuleFragment
    }
  }
  fragment ContentBodyLineFragment on LiferayPageLine {
    bodyItem {
      position
      contentBody {
        __typename
        ...SliderHeroFragment
        ...FeaturedProductFragment
        ...PurchaseMotivationFragment
        ...PromoFragment
        ...BlogPageFragment
        ...ServiceFragment
        ...NewsletterFragment
        ...EditorialFragment
        ...DynamicTriplettaListingFragment
        ...GalleryFragment
        ...CompareFragment
        ...IntroFragment
        ...OnlineStoreFragment
        ...AssistanceFragment
        ...AssistanceFooterFragment
        ...StoreLocationFragment
        ...FormConfigurationFragment
        ...BookletFragment
        ...FaqPageFragment
        ...ServiceMapsFragment
        ...RequestRepairFormFragment
        ...FaqWashPassFragment
        ...ProductNotesFragment
        ...HighLightFragment
        ...SwitchFragment
        ...InfoModuleFragment
        ...EditorialPushFragment
        ...WashpassCodeValidatorFragment
        ...AccordionInfoFragment
        ...ProductAppFragment
        ...PinFragment
        ...HtmlTextFieldFragment
        ...CategoryModuleFragment
      }
    }
  }
  fragment ContentBodyCrossLineFragment on LiferayPageCrossLine {
    bodyItem {
      position
      contentBody {
        __typename
        ...SliderHeroFragment
        ...FeaturedProductFragment
        ...PurchaseMotivationFragment
        ...PromoFragment
        ...BlogPageFragment
        ...ServiceFragment
        ...NewsletterFragment
        ...EditorialFragment
        ...DynamicTriplettaListingFragment
        ...GalleryFragment
        ...CompareFragment
        ...IntroFragment
        ...OnlineStoreFragment
        ...AssistanceFragment
        ...AssistanceFooterFragment
        ...StoreLocationFragment
        ...FormConfigurationFragment
        ...BookletFragment
        ...FaqPageFragment
        ...ServiceMapsFragment
        ...RequestRepairFormFragment
        ...FaqWashPassFragment
        ...ProductNotesFragment
        ...HighLightFragment
        ...SwitchFragment
        ...InfoModuleFragment
        ...EditorialPushFragment
        ...WashpassCodeValidatorFragment
        ...AccordionInfoFragment
        ...ProductAppFragment
        ...PinFragment
        ...HtmlTextFieldFragment
        ...CategoryModuleFragment
      }
    }
  }
`;
